import * as React from "react";
import { styled } from "styled-components";

const DataElementWrapper = styled.dl`
  justify-content: space-between;
`;

const DataElementLabel = styled.dt.attrs({ "data-testid": "data-element-label" } as Partial<
  React.HTMLAttributes<HTMLElement>
>)`
  font-weight: bold;
`;

const DataElementValue = styled.dd.attrs({ "data-testid": "data-element-value" } as Partial<
  React.HTMLAttributes<HTMLElement>
>)`
  margin-inline-start: 0;
`;

export const DataElement: React.FC<React.PropsWithChildren<{ label: string }>> = ({ label, children }) => {
  return (
    <DataElementWrapper>
      <DataElementLabel>{label}</DataElementLabel>
      <DataElementValue aria-label={label}>{children}</DataElementValue>
    </DataElementWrapper>
  );
};
